export default __webpack_public_path__ + "static/media/css.ac0e06fd.png";